import { lazy } from "react";

import { useNavigate } from "react-router-dom";

import cx from 'classnames';

import CourseAssessmentIcon from "../../../../../src/assets/images/course-assessment-icon.svg";
import CertificateIcon from "../../../../../src/assets/images/certificatee-icon.svg";
import RightChevron from "../../../../../src/assets/images/right-chevron-black.svg";

import LottieAnimationFile from "../../../../assets/lotties/certificate-confetti.json";

import Modal from "../../../modal/Modal";

import Button from "../ButtonComponent";
import { BUTTON_VARIANTS } from "../constant";

import { IS_RETAKE_ATTEMPT, LMS_COURSE_ID, LMS_COURSE_NAME, RETAKE_VIEW } from "../../../../utils/cookiesmanager";

import styles from "./styles.module.scss";
import { useGetTranslatedText } from "../queries";
import { getTranslatedText } from "../../../../utils/getTranslatedText";

const LottiePlayerClient = lazy(() => import("../Lottie/index"));

const CertificateCourseCompleteModal = (props) => {
  const { show , handleBackToCourse } = props;

  const navigate = useNavigate();

  const courseId = localStorage.getItem(LMS_COURSE_ID);
  const courseTitle = localStorage.getItem(LMS_COURSE_NAME);

  const isRetakeOptionAvailable = localStorage.getItem(RETAKE_VIEW);

  const userData  = JSON.parse(localStorage.getItem('user')) || {};

  const {firstName , lastName , userTypeId} = userData || {};

  const languageId = localStorage.getItem("l_id") || 1;
      
  const {data:translatedTextResponse} = useGetTranslatedText(languageId)
          
  const {data:translatedText = []} = translatedTextResponse || {};

  const handleClick = () => {
  localStorage.setItem(IS_RETAKE_ATTEMPT,true);

  navigate(`/user/post-course-assessment?courseId=${courseId}&courseName=${courseTitle}`);
  }

  return (
    <>
      <Modal visible={show}>
        <div className={styles["certificate-wrapper"]}>
          <div className={styles["confetti-wrapper"]}>
            <LottiePlayerClient
              animationData={LottieAnimationFile}
              loop={false}
              autoplay
            />
          </div>

          <div className={styles["content-wrapper"]}>
            <div className={styles["certificate-icon"]}>
              <img src={CertificateIcon} alt="" />
            </div>

            <div className={styles.title}>Dear {firstName} {lastName}</div>

            <div className={styles.description}>
              You have earned your Course Completion Certificate for {courseTitle}
              <p className={styles["para-text"]}>
                {getTranslatedText(translatedText, "key_download_certificate_menu" ,'You can download it from the Certificate menu.')}
              </p>
            </div>

            {(isRetakeOptionAvailable === '1' && userTypeId !== 12) && <div className={cx(styles.course , styles['cursor-pointer'])} onClick={handleClick}>
              <div className={styles["course-id"]}>
                <img src={CourseAssessmentIcon} alt="assessment" />
              </div>

              <div className={styles["course-detail"]}>
                <p className={styles["course-description"]}>
                  {getTranslatedText(translatedText, "key_course_assessment" ,'Course assessment')}
                </p>

                <p className={styles["course-complete"]}>
                  Certificate earned. You can try once more for an Excellence Certificate.
                </p>
              </div>

              <img src={RightChevron} alt="Icon" />
            </div>}

           <div className={styles["button-wrapper"]}>
              <Button
                label="Back to Course"
                buttonVariant={BUTTON_VARIANTS.PRIMARY}
                onClick={handleBackToCourse}
                className={styles.button}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CertificateCourseCompleteModal;
